import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { formatDate, formatTime } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Colors } from "../../../constants/styles";
import {
  Box,
  Typography,
  TextField,
  ButtonGroup,
  Button,
  Divider,
  Autocomplete,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import { Col, Row, Form } from "react-bootstrap";

const readTunggakanStream = async (payload, onProgress = () => {}) => {
  const response = await fetch(`${tempUrl}/jualsForTunggakanStream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let message = `Gagal memuat laporan (${response.status})`;
    try {
      const errorBody = await response.json();
      message = errorBody.message || message;
    } catch (_) {
      // Keep the HTTP status when the server did not return JSON.
    }
    throw new Error(message);
  }

  if (!response.body) throw new Error("Browser tidak mendukung streaming laporan");

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  const rows = [];
  let buffer = "";
  let finished = false;

  const consume = (line) => {
    if (!line.trim()) return;
    const message = JSON.parse(line);
    if (message.type === "rows") rows.push(...(message.rows || []));
    if (message.type === "progress") onProgress(message);
    if (message.type === "error") throw new Error(message.message);
    if (message.type === "done") finished = true;
  };

  while (!finished) {
    const { value, done } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";
    lines.forEach(consume);
    if (done) break;
  }
  if (buffer.trim()) consume(buffer);
  return rows;
};

const formatReportDate = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const CariTunggakan = () => {
  const tableRef = useRef(null);
  const { user, setting, dispatch } = useContext(AuthContext);
  var date = new Date();
  const [cabangInput, setCabangInput] = useState("");
  const [inputPerTanggal, setInputPerTanggal] = useState(date);
  const [lebihDari, setLebihDari] = useState("");
  const [sampaiDengan, setSampaiDengan] = useState("");
  const [kodeMarketing, setKodeMarketing] = useState("");
  const [kodeSurveyor, setKodeSurveyor] = useState("");
  const [allCabang, setAllCabang] = useState([]);
  const [marketings, setMarketings] = useState([]);
  const [surveyors, setSurveyors] = useState([]);
  const [tunggakan, setTunggakan] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");

  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const columns = [
    { title: "No", field: "no" },
    { title: "No. Jual", field: "noJual" },
    { title: "Nama", field: "namaRegister" },
    { title: "Alm", field: "almRegister" },
    { title: "Tlp", field: "tlpRegister" },
    { title: "Tipe", field: "tipe" },
    { title: "Nopol", field: "nopol" },
    { title: "Thn", field: "tahun" },
    { title: "Ang", field: "angPerBulan" },
    { title: "Tenor", field: "tenor" },
    { title: "Sisa Bln", field: "sisaBulan" },
    { title: "Ke", field: "bayarKe" },
    { title: "JTO", field: "tglJatuhTempo" },
    { title: "Marketing", field: "marketing" },
    { title: "Surveyor", field: "surveyor" },
    { title: "MD1", field: "tglMd1" },
    { title: "SP", field: "tglSpTerakhir" },
    { title: "ST", field: "tglStTerakhir" },
    { title: "HR", field: "hr" },
    { title: "Titip", field: "titip" },
    { title: "Sweeping", field: "sweeping" },
  ];

  const marketingOptions = marketings.map((marketing) => ({
    label: `${marketing.kodeMarketing} - ${marketing.namaMarketing}`,
  }));

  const surveyorOptions = surveyors.map((surveyor) => ({
    label: `${surveyor.kodeSurveyor} - ${surveyor.namaSurveyor}`,
  }));

  const cabangOptions = allCabang.map((user) => ({
    label: `${user._id} - ${user.namaCabang}`,
  }));

  useEffect(() => {
    if (
      user.tipeUser === "OWN/DIREKSI" ||
      user.tipeUser === "DESKCALL" ||
      user.tipeUser === "HEADKOLEKTOR"
    ) {
      getMarketingAllCabang();
      getSurveyorAll();
      getAllCabang();
    } else {
      getMarketing();
      getSurveyor();
      setCabangInput(user.cabang._id);
    }
    setSampaiDengan("0");
    setLebihDari("0");
  }, []);

  const getAllCabang = async () => {
    setLoading(true);
    const allCabang = await axios.post(`${tempUrl}/cabangs`, {
      id: user._id,
      token: user.token,
    });
    setAllCabang(allCabang.data);
    setLoading(false);
  };

  const getMarketing = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/marketings`, {
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setMarketings(response.data);
    setLoading(false);
  };

  const getMarketingAllCabang = async () => {
    setLoading(true);
    const allMarketings = await axios.post(`${tempUrl}/marketingsAllCabang`, {
      id: user._id,
      token: user.token,
    });
    setMarketings(allMarketings.data);
    setLoading(false);
  };

  const getSurveyor = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/surveyors`, {
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setSurveyors(response.data);
    setLoading(false);
  };

  const getSurveyorAll = async () => {
    setLoading(true);
    const allSurveyors = await axios.post(`${tempUrl}/surveyorsAllCabang`, {
      id: user._id,
      token: user.token,
    });
    setSurveyors(allSurveyors.data);
    setLoading(false);
  };

  const downloadPdf = async () => {
    setLoading(true);
    try {
      let tempPersenLoading = parseInt(persenLoading);
      let perTanggal = formatDate(inputPerTanggal);
    const tempMarketing = kodeMarketing
      ? await axios.post(`${tempUrl}/marketingByKode`, {
          kodeMarketing,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        })
      : { data: null };
    tempPersenLoading += 30;
    setPersenLoading(tempPersenLoading.toString());

    const tempSurveyor = kodeSurveyor
      ? await axios.post(`${tempUrl}/surveyorByKode`, {
          kodeSurveyor,
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        })
      : { data: null };
    tempPersenLoading += 30;
    setPersenLoading(tempPersenLoading.toString());

    const responseData = await readTunggakanStream({
      perTanggal: formatReportDate(inputPerTanggal),
      lebihDari,
      sampaiDengan,
      kodeMarketing: tempMarketing.data ? tempMarketing.data._id : null,
      kodeSurveyor: tempSurveyor.data ? tempSurveyor.data._id : null,
      id: user._id,
      token: user.token,
      kodeCabang: cabangInput,
      mode: "display",
    }, (progress) => {
      setPersenLoading(Math.min(95, 10 + Math.floor((progress.processed || 0) / 100)).toString());
    });
    tempPersenLoading += 30;
    setPersenLoading(tempPersenLoading.toString());

    var date = new Date();
    var current_date = formatDate(date);
    var current_time = formatTime(date);
    const doc = new jsPDF("l", "mm", [480, 210]);
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.lokasiPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Laporan Tunggakan`, 200, 30);
    doc.setFontSize(10);
    doc.text(`Per Tanggal : ${perTanggal}`, 15, 35);
    doc.text(
      `Cabang : ${cabangInput === "" ? "SEMUA CABANG" : cabangInput}`,
      15,
      40
    );
    doc.text(
      `Marketing : ${
        kodeMarketing === ""
          ? "SEMUA MARKETING"
          : `${kodeMarketing} - ${tempMarketing.data.namaMarketing}`
      }`,
      15,
      45
    );
    doc.text(
      `Surveyor : ${
        kodeSurveyor === ""
          ? "SEMUA SURVEYOR"
          : `${kodeSurveyor} - ${tempSurveyor.data.namaSurveyor}`
      }`,
      15,
      50
    );
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      200
    );
    doc.setFontSize(12);
    doc.autoTable({
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 55,
      columns: columns.map((col) => ({ ...col, dataKey: col.field })),
      body: responseData,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      didParseCell: function (data) {
        if (data.section === "body" && data.cell.raw === "Sweeping") {
          for (let i = 0; i <= 19; i++) {
            data.row.cells[`${i}`].styles.fillColor = Colors.yellow400;
          }
        }
        if (data.section === "body" && data.cell.raw === "Titip") {
          for (let i = 0; i <= 19; i++) {
            data.row.cells[`${i}`].styles.fillColor = Colors.red400;
          }
        }
      },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 30 },
        2: { cellWidth: 35 },
        3: { cellWidth: 60 },
        4: { cellWidth: 30 },
        5: { cellWidth: 25 },
        6: { cellWidth: 25 },
        7: { cellWidth: 15 },
        8: { cellWidth: 20 },
        9: { cellWidth: 10 },
        10: { cellWidth: 10 },
        11: { cellWidth: 10 },
        12: { cellWidth: 25 },
        13: { cellWidth: 20 },
        14: { cellWidth: 20 },
        15: { cellWidth: 25 },
        16: { cellWidth: 25 },
        17: { cellWidth: 25 },
        18: { cellWidth: 15 },
        19: { cellWidth: 15 },
        20: { cellWidth: 15 },
        // etc
      },
    });
      window.open(URL.createObjectURL(doc.output("blob")));
    } catch (requestError) {
      console.error(requestError);
      setError(true);
    } finally {
      setLoading(false);
      setPersenLoading("0");
    }
  };

  const getTunggakan = async () => {
    setLoading(true);
    try {
      let perTanggal = formatReportDate(inputPerTanggal);
      const tempMarketing = kodeMarketing
        ? await axios.post(`${tempUrl}/marketingByKode`, {
            kodeMarketing,
            id: user._id,
            token: user.token,
            kodeCabang: user.cabang._id,
          })
        : { data: null };
      const tempSurveyor = kodeSurveyor
        ? await axios.post(`${tempUrl}/surveyorByKode`, {
            kodeSurveyor,
            id: user._id,
            token: user.token,
            kodeCabang: user.cabang._id,
          })
        : { data: null };
      const responseData = await readTunggakanStream({
      perTanggal,
      lebihDari,
      sampaiDengan,
      kodeMarketing: tempMarketing.data ? tempMarketing.data._id : null,
      kodeSurveyor: tempSurveyor.data ? tempSurveyor.data._id : null,
      id: user._id,
      token: user.token,
      kodeCabang: cabangInput,
      mode: "excel",
    }, (progress) => {
      setPersenLoading(Math.min(95, 10 + Math.floor((progress.processed || 0) / 100)).toString());
      });
      setTunggakan(responseData);
    } catch (requestError) {
      console.error(requestError);
      setError(true);
    } finally {
      setLoading(false);
      setPersenLoading("0");
    }
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "TUNGGAKAN",
    sheet: "TUNGGAKAN",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Box>
      <Typography color="#757575">Laporan</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Laporan Tunggakan
      </Typography>
      <Divider sx={dividerStyle} />
      <Box sx={showDataWrapper}>
        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="3" style={textRight}>
                Cabang :
              </Form.Label>
              {user.tipeUser === "OWN/DIREKSI" ||
              user.tipeUser === "DESKCALL" ||
              user.tipeUser === "HEADKOLEKTOR" ? (
                <Col sm="9">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={cabangOptions}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        error={error && cabangInput.length === 0 && true}
                        helperText={
                          error &&
                          cabangInput.length === 0 &&
                          "Cabang harus diisi!"
                        }
                        placeholder="SEMUA CABANG"
                        {...params}
                      />
                    )}
                    onInputChange={(e, value) => {
                      setCabangInput(value.split(" ", 1)[0]);
                    }}
                  />
                </Col>
              ) : (
                <Col sm="9">
                  <Form.Control value={cabangInput} disabled />
                </Col>
              )}
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="3" style={textRight}>
                Dari Tanggal :
              </Form.Label>
              <Col sm="9">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={inputPerTanggal}
                  onChange={(e) => setInputPerTanggal(e)}
                  customInput={
                    <TextField
                      error={error && inputPerTanggal === null && true}
                      helperText={
                        error &&
                        inputPerTanggal === null &&
                        "Dari Tanggal harus diisi!"
                      }
                      sx={{ width: "100%" }}
                      size="small"
                    />
                  }
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="3" style={textRight}>
                Kode Marketing :
              </Form.Label>
              <Col sm="9">
                <Autocomplete
                  size="small"
                  disablePortal
                  id="combo-box-demo"
                  options={marketingOptions}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      error={error && kodeMarketing.length === 0 && true}
                      helperText={
                        error &&
                        kodeMarketing.length === 0 &&
                        "Kode Marketing harus diisi!"
                      }
                      placeholder="SEMUA MARKETING"
                      {...params}
                    />
                  )}
                  onInputChange={(e, value) =>
                    setKodeMarketing(value.split(" ", 1)[0])
                  }
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="3" style={textRight}>
                Kode Surveyor :
              </Form.Label>
              <Col sm="9">
                <Autocomplete
                  size="small"
                  disablePortal
                  id="combo-box-demo"
                  options={surveyorOptions}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      error={error && kodeSurveyor.length === 0 && true}
                      helperText={
                        error &&
                        kodeSurveyor.length === 0 &&
                        "Kode Surveyor harus diisi!"
                      }
                      placeholder="SEMUA SURVEYOR"
                      {...params}
                    />
                  )}
                  onInputChange={(e, value) =>
                    setKodeSurveyor(value.split(" ", 1)[0])
                  }
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="3" style={textRight}>
                Lebih Dari :
              </Form.Label>
              <Col sm="9">
                <Form.Control
                  type="number"
                  required
                  value={lebihDari}
                  onChange={(e) => {
                    setLebihDari(e.target.value);
                  }}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextPassword"
            >
              <Form.Label column sm="3" style={textRight}>
                Sampai Dengan :
              </Form.Label>
              <Col sm="9">
                <Form.Control
                  type="number"
                  required
                  value={sampaiDengan}
                  onChange={(e) => {
                    setSampaiDengan(e.target.value);
                  }}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
      </Box>
      <Box sx={spacingTop}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <Button
            startIcon={<DownloadIcon />}
            onClick={() => {
              getTunggakan();
            }}
          >
            EXCEL
          </Button>
        </ButtonGroup>
      </Box>
      {tunggakan.length > 0 && (
        <>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<DownloadIcon />}
            sx={{ marginTop: "10px" }}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        </>
      )}
      <table
        ref={tableRef}
        style={{ visibility: tunggakan.length > 0 ? "visible" : "hidden" }}
      >
        <tbody>
          <tr>
            <th>kontrak</th>
            <th>nama</th>
            <th>alamat</th>
            <th>kd_kec</th>
            <th>kecamatan</th>
            <th>tjt</th>
            <th>tlp</th>
            <th>tenor</th>
            <th>ke</th>
            <th>sisa</th>
            <th>mundur</th>
            <th>mkt</th>
            <th>nama_mkt</th>
            <th>sur</th>
            <th>nama_sur</th>
            <th>surbaru</th>
            <th>nmsurbaru</th>
            <th>tsp</th>
            <th>tglstrk</th>
            <th>tipe</th>
            <th>thn</th>
            <th>ang</th>
            <th>denda</th>
            <th>htgdenda</th>
            <th>bp</th>
            <th>tglsp</th>
            <th>ket2</th>
            <th>dp</th>
            <th>s_piutang</th>
            <th>s_modal</th>
            <th>s_bunga</th>
            <th>tgltitip</th>
            <th>bayar</th>
            <th>telat</th>
          </tr>
          {tunggakan.map((item, i) => (
            <tr>
              <th>{item.kontrak}</th>
              <th>{item.nama}</th>
              <th>{item.alamat}</th>
              <th>{item.kd_kec}</th>
              <th>{item.kecamatan}</th>
              <th>{item.tjt}</th>
              <th>{item.tlp}</th>
              <th>{item.tenor}</th>
              <th>{item.ke}</th>
              <th>{item.sisa}</th>
              <th>{item.mundur}</th>
              <th>{item.mkt}</th>
              <th>{item.nama_mkt}</th>
              <th>{item.sur}</th>
              <th>{item.nama_sur}</th>
              <th>{item.surbaru}</th>
              <th>{item.nmsurbaru}</th>
              <th>{item.tsp}</th>
              <th>{item.tglstrk}</th>
              <th>{item.tipe}</th>
              <th>{item.thn}</th>
              <th>{item.ang}</th>
              <th>{item.denda}</th>
              <th>{item.htgdenda}</th>
              <th>{item.bp}</th>
              <th>{item.tglsp}</th>
              <th>{item.ket2}</th>
              <th>{item.dp}</th>
              <th>{item.s_piutang}</th>
              <th>{item.s_modal}</th>
              <th>{item.s_bunga}</th>
              <th>{item.tgltitip}</th>
              <th>{item.bayar}</th>
              <th>{item.telat}</th>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default CariTunggakan;

const subTitleText = {
  fontWeight: "900",
};

const dividerStyle = {
  mt: 2,
};

const spacingTop = {
  mt: 4,
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
};
